/**
 * Mobile-menu A/B test — async runtime layer (docs: AGENTS.md, "Mobile nav drawer").
 *
 * The synchronous variant (control = accordion drawer, treatment = drill-down drawer) is resolved in
 * mobile-menu-variant-bootstrap.liquid, which sets window.villoidMobileMenuVariant before either drawer
 * shell renders. This file:
 *   - reconciles the bootstrap value against Amplitude Experiment's allocation (caches the server value
 *     for the next load — no mid-session flip, same approach as ab_test_search_popup.js);
 *   - exposes window.villoidFireMobileMenuExposure(), called (via events.js header_menu_open) when the
 *     burger opens the menu. Same call in both arms, so exposure is symmetric.
 *
 * Mirrors assets/ab_test_search_popup.js.
 */
(function () {
  var FLAG_KEY = 'mobile-menu';
  var DEPLOYMENT_KEY = 'client-lZNt2kUlhDZnGjxzZtT3Grewba9cN2DO';
  var CACHE_KEY = 'mobile_menu_variant';

  var client = null;
  var fetched = false;
  var exposurePending = false;

  function isVariant(v) { return v === 'control' || v === 'treatment'; }

  function writeCache(variant) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ variant: variant, ts: Date.now() })); } catch (e) {}
  }

  function waitFor(predicate, callback, maxAttempts, interval) {
    maxAttempts = maxAttempts || 50;
    interval = interval || 100;
    var attempts = 0;
    (function check() {
      if (predicate()) return callback();
      if (++attempts > maxAttempts) return;
      setTimeout(check, interval);
    })();
  }

  // Exposure is for the server-assigned variant, so it must wait for fetch(): before that the SDK has no
  // allocation to report. If the burger is tapped first, remember it and fire once fetch() resolves.
  function fireExposure() {
    if (client && fetched) {
      try { client.exposure(FLAG_KEY); } catch (e) {}
    } else {
      exposurePending = true;
    }
  }
  window.villoidFireMobileMenuExposure = fireExposure;

  function reconcile() {
    waitFor(function () { return !!window.Experiment; }, function () {
      try {
        client = window.Experiment.initializeWithAmplitudeAnalytics(DEPLOYMENT_KEY, {
          serverZone: 'EU',
          automaticExposureTracking: false
        });
      } catch (e) {
        console.warn('[mobile-menu-ab] Experiment init failed:', e);
        return;
      }

      client.fetch().then(function () {
        var result = client.variant(FLAG_KEY);
        var server = result && result.value;
        // Cache for the NEXT load — never flip the live session, the drawer shell is already chosen.
        // Written every time (not only on mismatch) so the cache keeps sliding while the user returns.
        if (isVariant(server)) writeCache(server);
        fetched = true;
        if (exposurePending) {
          exposurePending = false;
          try { client.exposure(FLAG_KEY); } catch (e) {}
        }
      }).catch(function (err) {
        console.warn('[mobile-menu-ab] experiment.fetch() failed:', err);
      });
    });
  }

  function init() {
    // Mobile only: the burger is hidden on desktop, so don't spend a fetch there.
    var burger = document.querySelector('.js-drawer-open-nav');
    if (!burger || burger.offsetParent === null) return;
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
